import { render, staticRenderFns } from "./ReporteBajaBien.vue?vue&type=template&id=4e6b0ae8"
import script from "./ReporteBajaBien.vue?vue&type=script&lang=js"
export * from "./ReporteBajaBien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports